function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "_clipPath_1a9a5dcAlz6yrts7rTTg3zgluyYo9xUv"
}, /*#__PURE__*/React.createElement("rect", {
  width: 17.293,
  height: 22.234
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#_clipPath_1a9a5dcAlz6yrts7rTTg3zgluyYo9xUv)"
}, /*#__PURE__*/React.createElement("path", {
  d: " M 12.577 9.433 C 9.972 9.433 7.861 7.321 7.861 4.716 C 7.861 2.112 9.972 0 12.577 0 C 15.182 0 17.293 2.112 17.293 4.716 C 17.293 7.321 15.182 9.433 12.577 9.433 Z  M 4.716 22.234 C 2.112 22.234 0 20.123 0 17.518 C 0 14.913 2.112 12.802 4.716 12.802 C 7.321 12.802 9.433 14.913 9.433 17.518 C 9.433 20.123 7.321 22.234 4.716 22.234 Z ",
  fillRule: "evenodd",
  fill: "rgb(82,87,255)"
}));

var SvgLogo = function SvgLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    style: {
      isolation: "isolate"
    },
    viewBox: "0 0 17.293 22.234",
    width: "17.293pt",
    height: "22.234pt",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo.974457ab.svg";
export { ForwardRef as ReactComponent };